import React, { FC } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { Icon } from '@iconify/react';
import TextField from '../../components/TextField/TextField';
import Button from '../../components/Button/Button';

type Props = {
  // onSearch: (searchText: string) => void;
  onToggleToolPanelClick: (panelId: 'columns' | 'filters') => void;
  setInputText: any;
  inputText: any;
};

const GridTopActions: FC<Props> = ({ onToggleToolPanelClick, setInputText, inputText }) => {
  return (
    <Stack mt={-10} mb={5} direction="row" p={1} alignItems="center" justifyContent="flex-end" gap={2}>
      <Box width={300}>
        <TextField
          placeholder="Search..."
          sx={{ width: 1000, maxWidth: '100%' }}
          fullWidth
          value={inputText}
          endIcon={<Icon icon="ant-design:search-outlined" />}
          onChange={(e) => setInputText(e.target.value)}
        />
      </Box>
      <Box>
        <Button
          size="small"
          startIcon={<Icon icon="fluent:column-triple-20-regular" />}
          onClick={() => onToggleToolPanelClick('columns')}
        >
          Manage Columns
        </Button>
      </Box>
      <Divider orientation="vertical" flexItem />
      <Box>
        <Button
          size="small"
          startIcon={<Icon icon="cil:list-filter" />}
          onClick={() => onToggleToolPanelClick('filters')}
        >
          Filters
        </Button>
      </Box>
    </Stack>
  );
};

export default GridTopActions;
